/* eslint-disable @typescript-eslint/no-unused-vars */
import { InboxOutlined } from "@ant-design/icons";
import { Modal, Upload, UploadFile } from "antd";
import React, { useEffect, useState } from "react";
import { InvoiceServices } from "../../../services/invoice";
import { useMessageApi } from "../../../context/MessageContext";

const ACCEPT_FILE = "csv";

interface ImportInvoiceProps {
  isVisible: boolean;
  onClose: (okTriggered?: boolean) => void;
}

const ImportInvoice: React.FC<ImportInvoiceProps> = ({ isVisible, onClose }) => {
  const messageApi = useMessageApi();
  const [file, setFile] = useState<File | null>(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [errors, setErrors] = useState<any[]>([]);

  useEffect(() => {
    setFile(null);
  }, [isVisible]);

  const handleChangeFile = (info: { fileList: UploadFile[] }) => {
    if (info?.fileList[0]?.originFileObj) {
      setFile(info?.fileList[0]?.originFileObj);
    }
  };

  const handleImport = async () => {
    if (!file) return;
    try {
      setIsLoadingSubmit(true);
      setErrors([]);
      const formData = new FormData();
      formData.append("file", file);
      await InvoiceServices.importCsv(formData);
      messageApi.success(`Import Invoice successfully!`);
      onClose(true);
    } catch (err: any) {
      // If error details are available, set them
      if (err.details && Array.isArray(err.details)) {
        setErrors(err.details);
      } else {
        messageApi.error(err.message ?? `Import Invoice failed!`);
      }
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const renderTextUpload = () => (
    <>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag file to this area to upload</p>
      <p className="ant-upload-hint">Supported format: {ACCEPT_FILE}</p>
    </>
  );

  return (
    <Modal
      title="Import Flight SIR"
      open={isVisible}
      onCancel={() => onClose()}
      okText="Upload"
      onOk={handleImport}
      okButtonProps={{ disabled: !file }}
      confirmLoading={isLoadingSubmit}
    >
      <Upload.Dragger
        name="files"
        maxCount={1}
        accept={`.${ACCEPT_FILE}`}
        beforeUpload={() => false}
        onChange={handleChangeFile}
        onRemove={() => setFile(null)}
      >
        {renderTextUpload()}
      </Upload.Dragger>
      {errors.length > 0 && (
        <div
          style={{
            color: "red",
            marginTop: 16,
            maxHeight: 150,
            overflowY: "auto",
            background: "#f5f5f5",
            padding: 8,
            borderRadius: 4,
          }}
        >
          {errors.map((err: any, idx) => (
            <div key={idx}>{`Row ${err.rowIndex + 1} - ${err.message}`}</div>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default ImportInvoice;
